import type { LucideIcon } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

/** Grid oficial de hubs merchant (Catalogación, Configuración, Clientes, B2B, Ventas). */
export const MERCHANT_HUB_GRID = "grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-4";

export const MERCHANT_HUB_CARD_CLASS =
  "flex min-h-[9.5rem] flex-col justify-between rounded-xl border border-border bg-card p-card-padding text-left shadow-sm transition-all hover:border-border-strong hover:bg-surface-hover hover:shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary";

export interface DashboardCardProps {
  to?: string;
  /** Search params de la ruta destino (ej. hubs cuya vista se controla por query string). */
  search?: Record<string, string>;
  onClick?: () => void;
  icon: LucideIcon;
  title: string;
  subtitle: string;
  className?: string;
  active?: boolean;
  tourId?: string;
  /** Densidad para el mobile navigation hub — mismo lenguaje, menos altura. */
  compact?: boolean;
}

/** Tarjeta de navegación de módulo merchant — icono, título y descripción. */
export function DashboardCard({
  to,
  search,
  onClick,
  icon: Icon,
  title,
  subtitle,
  className,
  active,
  tourId,
  compact,
}: DashboardCardProps) {
  const classNameResolved = cn(
    MERCHANT_HUB_CARD_CLASS,
    compact && "min-h-[7.5rem] p-3",
    active && "border-primary/40 bg-primary/10",
    className,
  );

  const inner = (
    <>
      <Icon className={cn("text-primary", compact ? "mb-2 h-6 w-6" : "mb-4 h-8 w-8")} aria-hidden />
      <div>
        <p className="text-body-md font-bold text-foreground">{title}</p>
        {subtitle ? <p className="text-label-md text-muted-foreground">{subtitle}</p> : null}
      </div>
    </>
  );

  if (to) {
    return (
      <Link to={to} search={search} data-tour={tourId} data-nav-to={to} onClick={onClick} className={classNameResolved}>
        {inner}
      </Link>
    );
  }

  return (
    <button type="button" data-tour={tourId} onClick={onClick} className={classNameResolved}>
      {inner}
    </button>
  );
}
